import { z } from 'zod';
import { IdSchema } from './common.js';

// ----- Semáforo de abastecimiento (Etapa 2) -----
export const SupplyStatusSchema = z.enum(['GREEN', 'AMBER', 'RED']);

export const SupplySettingsSchema = z.object({
  /** Una referencia necesita reposición cuando su saldo <= mínimo × factor. */
  restock_factor: z.coerce.number().min(0.1).max(5),
  /** Porcentaje del surtido que pone al local en amarillo (reponer) y en rojo (sin inventario). */
  amber_pct: z.coerce.number().min(0).max(100),
  red_pct: z.coerce.number().min(0).max(100),
});

export const SupplyLocationSchema = z.object({
  location_id: z.number().int(),
  code: z.string(),
  name: z.string(),
  type: z.enum(['WAREHOUSE', 'STORE']),
  status: SupplyStatusSchema,
  refs: z.number().int(),
  out_of_stock: z.number().int(),
  restock: z.number().int(),
  normal: z.number().int(),
  units: z.number().int(),
  incoming_transit: z.number().int(),
  out_pct: z.number(),
  restock_pct: z.number(),
});

export const SupplyItemSchema = z.object({
  product_id: z.number().int(),
  ref: z.string(),
  product_name: z.string(),
  brand: z.string(),
  category: z.string(),
  qty: z.number().int(),
  min_stock: z.number().int(),
  /** true cuando el mínimo es propio de esa ubicación y no el general del producto. */
  own_minimum: z.boolean(),
  incoming_transit: z.number().int(),
  status: SupplyStatusSchema,
});

export const SupplySchema = z.object({
  settings: SupplySettingsSchema,
  locations: z.array(SupplyLocationSchema),
  items: z.array(SupplyItemSchema).nullable(),
});
export type Supply = z.infer<typeof SupplySchema>;
export type SupplyItem = z.infer<typeof SupplyItemSchema>;
export type SupplyLocation = z.infer<typeof SupplyLocationSchema>;

export const SupplyQuerySchema = z.object({
  location_id: IdSchema.optional(),
  only_alerts: z.enum(['true', 'false']).default('true').transform((v) => v === 'true'),
});

export const MinimumBodySchema = z.object({
  location_id: IdSchema,
  product_id: IdSchema,
  /** null vuelve al mínimo general del producto. */
  min_stock: z.number().int().min(0).max(1_000_000).nullable(),
});
